import React, { useState } from "react";
import { Container } from "reactstrap";
import WishlistCard from "./WishlistCard.js";
import "./WishlistCard.css"; // Custom CSS file
import img1 from "../../../../assets/images/boats/01.png";
import img2 from "../../../../assets/images/boats/02.png";
import img3 from "../../../../assets/images/boats/03.png";

const Wishlist = ({ BookMarkdata, onDelete }) => {
  const [wishlist, setWishlist] = useState([
    { id: 1, image: { img1 } },
    { id: 2, image: { img2 } },
    { id: 3, image: { img3 } },
    { id: 4, image: { img2 } },
    { id: 5, image: { img1 } },
  ]);

  const handleRemove = (id) => {
    setWishlist(wishlist.filter((item) => item.id !== id));
  };
  console.log("BookMarkdata", BookMarkdata);

  return (
    <Container>
      <div className="card p-2">
        <div className="card wishlist-header p-3">
          <h5>Wishlist</h5>
        </div>
        {BookMarkdata && BookMarkdata.length > 0 ? (
          BookMarkdata.map((item) => (
            <div key={item._id}>
              <WishlistCard item={item} onRemove={onDelete} />
              <hr />
            </div>
          ))
        ) : (
          <div className="no-result-container">
            <i className="mdi mdi-bookmark" style={{ fontSize: "56px" }}></i>
            <p>No bookmarks available to display.</p>
            <a href="/stocks" className="btn btn-primary">
              Back to Stock
            </a>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Wishlist;
